import { createStore } from 'satcheljs';
import CalendarCacheDiagnosticsStore from './schema/CalendarCacheDiagnosticsStore';

export default createStore<CalendarCacheDiagnosticsStore>('CalendarCacheDiagnosticsStore', {
    cacheUpdateLogs: [],
    selectedLogIndex: -1,
});
